export default function Manifesto() {
  return (
    <div>
      <div
        style={{
          maxWidth: 540,
          padding: 20,
          lineHeight: 1.3,
          paddingBottom: 100,
          margin: '10vh auto',
        }}
      >
        <h3>Manifesto</h3>
        <p>
          Humanity is most simply defined by a desire to form communities around
          ideas, symbols, and artifacts that satisfy our overlapping
          interpretations of beauty.
        </p>
        <p>
          Tiles are a celebration of what gives meaning to those communities:
          the individual. There is one Tile generated for every possible ETH
          wallet address—each representing a unique identity in the
          decentralized ecosystem that makes projects like this possible.
        </p>
        <p>
          Mathematically, all Tiles are equally rare. They are all fashioned
          from the same assortment of simple shapes and colors, but each in a
          unique way. In that sense, Tiles are a bit like us.
        </p>
        <p>
          Owning a Tile is an invitation to participate in the{' '}
          <a href="/#/dao">TileDAO</a>, which receives all revenue from the
          Tiles primary sale. Because the supply is virtually infinite, funding
          for the DAO may continue indefinitely—as long as Tiles are sold.
        </p>
        <p>
          How these funds are used will be the true experiment in creating
          value. In the future, Tiles will be defined not only by the artwork
          that gives them shape, but by what we build from them together.
        </p>
        <p>Thank you for being a part of it.</p>
        <p>- Tile artist</p>
      </div>
    </div>
  )
}
